import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const CERTIFICATIONTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.CertificationType.Name')
    .required()
    .maxLength(50)
    .build(),
];

export const CERTIFICATIONTYPE_CONFIG = {
  entityName: 'CertificationType',
  localizationKey: 'Planning::Entity.CertificationType',
  fields: CERTIFICATIONTYPE_FIELDS,
  permission: 'Planning.CertificationTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Certification + MENU_NAME_SUFFIX,
};
